// open n close accordions
/*
$('.accordion-module__title').click(function() {
  $('.accordion-module__content').slideUp('normal');
  if ($(this).next().is(':hidden') == true) {
    $(this).next().slideDown('normal');
    // $(this).next().toggle('normal');
  }
});
$('.accordion-module__content').hide();
*/

// Hide all accordion contents
$('.accordion-module__content').hide();
// New open n close accordions (Sebi)
$('.accordion-module__title').click(function(){
    if($(this).hasClass('active')){
        $(this).next().slideUp('normal');
    } else {
        $(this).next().slideDown('normal');
    }
    $(this).toggleClass('active');
    $(this).find('img').toggleClass('hide-acc-icon');
});



// WEBPACK FOOTER //
// ./assets/js/features/accordion.js